import { ROUTES } from 'config/routes'
import { berthApiClient } from 'repositories/BerthApi/berthApiClient'
import { signOutEndpoint } from 'repositories/BerthApi/signOut/endpoint'

import loginStorage from './loginStorage'
import { clearMfaChallenge } from './mfaChallengeStorage'
import { clearPostLoginRedirect } from './postLoginRedirect'

export const logout = async (): Promise<void> => {
  try {
    await berthApiClient.delete(signOutEndpoint())
  } catch {
    // API失敗してもローカルはクリアする
  }
  loginStorage.clearAuthData()
  // ログアウト後の再ログインで直前の画面に戻されないよう戻り先を破棄する
  clearPostLoginRedirect()
  // 認証完了せずログアウトに至った場合に備えて MFA challenge も破棄
  clearMfaChallenge()
  window.location.href = ROUTES.login
}
